import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MehTwoToneSvg from "@ant-design/icons-svg/es/asn/MehTwoTone";
import AntdIcon from "../components/AntdIcon";
var MehTwoTone = function MehTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MehTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MehTwoTone.displayName = 'MehTwoTone';
}
export default /*#__PURE__*/React.forwardRef(MehTwoTone);